<template>
  <div>
    <tabs v-if="tabs && tabs.length > 0">
      <tabs-item
        v-for="(tab, key) in tabs"
        :key="key"
        :active="key === activeTab"
        @click="setActiveTab(tab)"
        >{{ tab.title }}</tabs-item
      >
    </tabs>
    <section-block>
      <template slot="actions">
        <base-button
          :primary="true"
          iconBefore="link"
          :iconBeforeFill="false"
          type="button"
          @click="addLink"
          >Add Quick Link</base-button
        >
      </template>
      <div v-if="!loading && quickLinks">
        <vuetable
          class="c-data-table"
          :api-mode="false"
          :fields="table.fields"
          :data="quickLinks"
          ref="vuetable"
          @vuetable:row-clicked="editLink"
        ></vuetable>
      </div>
      <div v-else-if="!loading && quickLinks.length < 1">
        <p>You have added no links</p>
      </div>
      <loading v-else></loading>
    </section-block>
  </div>
</template>

<script>
import LinkActions from "@/components/LinkActions";
import { mapState } from "vuex";
import UserProfile from "@/mixins/UserProfile"
export default {
  name: "UserQuickLinks",

  mixins: [UserProfile],
  methods: {
    dataManager(sortOrder, pagination) {
      const returnObj = {
        ...this.$store.state.users.pagination,
        data: this.quickLinks,
      };

      return returnObj;
    },

    setActiveTab(tab) {
      this.$router.push({ path: tab.to });
    },

    addLink() {
      this.$router.push({ name: "CurrentUserQuickLinksAdd" });
    },
    editLink(row) {
      if (
        row.event.target.localName === "td" ||
        row.event.target.parentNode.localName === "td"
      ) {
        this.$router.push({
          name: "CurrentUserQuickLinksEdit",
          params: { id: row.data.id },
        });
      }
    },
  },

  data() {
    return {
      loading: true,
      table: {
        fields: [
          {
            name: "name",
            title: "Name",
            width: "40%",
          },
          {
            name: "url",
            title: "Link",
          },
          {
            name: LinkActions,
            title: "Actions",
            titleClass: "u-ta-center u-hide-mobile",
            dataClass: "u-ta-center u-hide-mobile",
            width: "10%",
          },
        ],
      },
    };
  },

  computed: {
    ...mapState("users", ["quickLinks"]),
  },

  beforeCreate() {
    this.$store.dispatch("users/getQuickLinks").then((resp) => {
      this.loading = false;
    });
  },
};
</script>

<style lang="scss" scoped></style>
